module.exports = __webpack_public_path__ + "img/cz-partners-czechcrunch.db3c565e.svg";